/*
 * 商品属性配置
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-30 19:45:01
 * @Last Modified by: fan.li@zuolin.com
 * @Last Modified time: 2019-12-20 14:35:50
 */

const api = {
	listProperties: '/property/listProperties', // 商品属性查询
	updateProperty: '/property/updateProperty', // 商品属性修改
	deleteProperty: '/property/deleteProperty', // 商品属性删除
	getProperty: '/property/getProperty', // 查询商品属性
	addProperty: '/property/addProperty', // 新增商品属性

};

const routes = {
	'/good-property': '商品属性'
};

export {
	api,
	routes,
};
